<template>
  <b-field>
    <b-datepicker
      icon="calendar"
      :placeholder="label"
      :month-names="monthNames"
      :day-names="dayNames"
      :type="type"
      :value="value"
      @input="updateValue($event)"
    >
    </b-datepicker>
  </b-field>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: Date
    },
    type: {
      type: String
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
      this.$emit("dateChanged");
    }
  },
  computed: {
    monthNames() {
      return [
        this.$t("date.january"),
        this.$t("date.february"),
        this.$t("date.march"),
        this.$t("date.april"),
        this.$t("date.may"),
        this.$t("date.june"),
        this.$t("date.july"),
        this.$t("date.august"),
        this.$t("date.september"),
        this.$t("date.october"),
        this.$t("date.november"),
        this.$t("date.december")
      ];
    },
    dayNames() {
      return [
        this.$t("date.sunday"),
        this.$t("date.monday"),
        this.$t("date.thuesday"),
        this.$t("date.wednesday"),
        this.$t("date.thursday"),
        this.$t("date.friday"),
        this.$t("date.saturday")
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .control {
    max-width: 180px;
  }
}
</style>
